/* @flow */

import * as React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getEventId } from '@e180/domain/lib/event/util';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { fetchEvent } from 'src/shared/domain/event/action/eventActions';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import { getEvent } from 'src/shared/domain/event/selector/eventSelectors';
import { fetchMembershipOptimally } from 'src/shared/domain/membership/action/membershipActions';
import useMembership from 'src/shared/domain/membership/hook/useMembership';
import { fetchSelfOptimally } from 'src/shared/domain/user/action/userActions';
import useSelf from 'src/shared/domain/user/hook/useSelf';

export default function useInitialPayloadFetching() {
  const token = useSelector(getAuthenticationToken);
  const dispatch = useDispatch();
  const user = useSelf();
  const membership = useMembership();
  const safeEvent = useEvent();
  const privateEvent = useSelector(getEvent, shallowEqual);

  React.useEffect(() => {
    if (token) {
      const eventId = getEventId(safeEvent);

      if (!user) {
        dispatch(fetchSelfOptimally());
      }

      if (!membership) {
        dispatch(fetchMembershipOptimally(eventId));
      }

      if (!privateEvent) {
        dispatch(fetchEvent(eventId));
      }
    }
  }, [token]);
}
